import 'dotenv/config';

import QA from './Qa';
import QA_DEVELOP from './QaDev';
import PRODUCTION from './Production';
import DEVELOPMENT from './Development';

const Environment = (() => {
  const environment = process.env.NODE_ENV;
  switch (environment) {
    case 'production':
      return PRODUCTION;
    case 'qa':
      return QA;
    case 'qa-dev':
      return QA_DEVELOP;
    default:
      return DEVELOPMENT;
  }
})();

export default Environment;
